import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import {
  LoadStatusPageIncidentsError,
  LoadStatusPageIncidentsSuccess,
} from 'src/redux/global/actions/statuspage';
import { getIncidents } from 'src/redux/global/api/statuspage-api';

const StatuspagePoller = () => {
  const dispatch = useDispatch();
  const [polling, setPolling] = useState(true);

  useEffect(() => {
    const pollStatuspageOnInterval = async () => {
      if (!document.hidden && polling) {
        try {
          const resp = await getIncidents();
          dispatch(LoadStatusPageIncidentsSuccess(resp));
        } catch (e) {
          dispatch(LoadStatusPageIncidentsError(e.message));
          setPolling(false);
        }
      }
    };
    pollStatuspageOnInterval();
    const interval = setInterval(pollStatuspageOnInterval, 60000);
    return () => clearInterval(interval);
  }, [dispatch, polling]);

  return null;
};

// eslint-disable-next-line import/no-default-export
export default StatuspagePoller;
